module.exports = __webpack_public_path__ + "img/04_maska_mazok_2.85a13d0.svg";